import { makeStyles } from '@lifeomic/chroma-react/styles';
import * as React from 'react';
import clsx from 'clsx';
import { messages } from './IndicatorLegend';
import { useIntl } from 'react-intl';
import { Star } from '@lifeomic/chromicons';

const useStyles = makeStyles(theme => ({
  root: {
    width: theme.pxToRem(15),
    height: theme.pxToRem(15),
    marginTop: theme.pxToRem(-1),
    '& *': {
      strokeWidth: 0,
    },
  },
  star: {
    '& *': {
      fill: theme.palette.blue[500],
    },
  },
}));

interface AlternateIndicatorProps {
  className?: string;
}

export const AlternateIndicator: React.FC<AlternateIndicatorProps> = ({
  className,
  ...rootProps
}) => {
  const { formatMessage } = useIntl();
  const classes = useStyles({});

  return (
    <Star
      className={clsx(classes.root, classes.star, className)}
      aria-label={formatMessage(messages.alternateVariant)}
      {...rootProps}
    />
  );
};
